<template>
  <v-snackbar :timeout="-1" color="light-blue-darken-2" location="top right">
    <v-icon :icon="mdiCartArrowRight" />

    <template #actions>
      <v-btn variant="text" @click="$emit('continue')">Continue Checkout</v-btn>
      <v-btn variant="text" @click="$emit('dismiss')">Dismiss</v-btn>
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import { mdiCartArrowRight } from '@mdi/js'

defineEmits(['continue', 'dismiss'])
</script>
